import React from "react";

import { useMediaQuery } from "react-responsive";
import LiveAside from "./components/LiveAside";
import TodayAside from "./components/TodayAside";
import UpcommingAside from "./components/UpcommingAside";
import { useNavigate } from "react-router-dom";

function RightAsideComponent() {
  const isDastop = useMediaQuery({ query: "(max-width: 1420px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1050px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 886px)" });
  const navigate = useNavigate();
  return (
    <div
      className={`cover p-1 ${
        isTablet ? "mt-1" : "horizontal-scroll-bar custom-scrollbar white"
      }`}
      style={{
        width: isTablet ? "100%" : isLaptop ? "33%" : isDastop ? "27%" : "21%",
        position: !isTablet && "fixed",
        right: 0,
        backgroundColor: "#f2f4fdF",
        border: "1px solid #6f2da8",
        paddingBottom: !isTablet && "6rem",
      }}
    >
      <div className="valign-wrapper space-between">
        <h5 className="black-text margin-0px">Live Auctions</h5>
        <p
          className="cover pointer today-auctions margin-0px"
          style={{ padding: "3px 10px" }}
          onClick={() => {
            navigate("/seller-live-auctions");
          }}
        >
          All Live Auctions
        </p>
      </div>
      <LiveAside />

      <h5 className="black-text mt-2">Today’s Auctions</h5>
      <TodayAside />

      <h5 className="black-text mt-2">Upcoming Auctions</h5>
      <UpcommingAside />
    </div>
  );
}

export default RightAsideComponent;
